import React, { useContext } from 'react';
import { Breadcrumb, Button, Table, Tag } from 'antd';
import { LeftOutlined, TagOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import useViewAppUserVouchers from './useViewAppUserVouchers';
import PageHeader from '../../../components/PageHeader';
import TableCard from '../../../components/TableCard';
import TableDicaHint from '../../../components/TableDicaHint';
import TablePagination from '../../../components/TablePagination';
import { ThemeContext } from '../../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../../utils/Conversores';

export default function ViewAppUserVouchers() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        appUser,
        tableData,
        isLoading,
        pagination,
        columns,
        handleClickGoBack,
        handlePaginationChange,
        navigate,
    } = useViewAppUserVouchers();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div
                style={{
                    background: isDark ? '#141414' : '#ffffff',
                    borderRadius: 10,
                    border: `1px solid ${isDark ? '#262626' : '#eaedf1'}`,
                    padding: '10px 16px',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Breadcrumb
                    items={[
                        {
                            title: <Link to="/usuarios/aplicativo">Cidadãos</Link>,
                        },
                        {
                            title: (
                                <Link to={`/usuarios/aplicativo/visualizar/${appUser?.id}`}>
                                    {appUser?.name || 'Cidadão'}
                                </Link>
                            ),
                        },
                        {
                            title: 'Vouchers',
                        },
                    ]}
                />
            </div>

            <PageHeader
                icon={<TagOutlined />}
                title={appUser?.name ? `Vouchers de ${appUser.name}` : 'Vouchers do Cidadão'}
                subtitle="Acompanhe todo o histórico de resgates e vouchers emitidos para este cidadão"
                tag={<Tag color="blue">{poeValorComPontosEmMil(tableData.length)} vouchers</Tag>}
                actions={
                    <Button
                        icon={<LeftOutlined />}
                        onClick={handleClickGoBack}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            fontWeight: 600,
                            height: 38,
                            borderRadius: 8,
                        }}
                    >
                        Voltar
                    </Button>
                }
            />

            <TableDicaHint text="Dê um clique na linha ou utilize o botão de ação à direita para visualizar os detalhes do voucher." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="vouchers"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData.slice(
                        (pagination.current - 1) * pagination.pageSize,
                        pagination.current * pagination.pageSize
                    )}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 1000 }}
                    onRow={(record) => ({
                        onClick: () => {
                            navigate(`/vouchers/${record.redemption_code}`);
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={tableData.length}
                itemName="vouchers"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />
        </div>
    );
}